import {RouterModule, Routes} from "@angular/router";
import {NgModule} from "@angular/core";
import {EditorPanelComponent} from "./editor-panel.component";
import {AuthGuard} from "../auth/services/auth.guard";
import {Role} from "../auth/models/Role";
import {EditorNewsComponent} from "./editor-news/editor-news.component";
import {EditorEditNewsComponent} from "./editor-news/editor-edit-news/editor-edit-news.component";
import {EditorCreateNewsComponent} from "./editor-news/editor-create-news/editor-create-news.component";
import {UserProfileComponent} from "./user-profile/user-profile.component";

const routes: Routes = [
  {
    path: 'editor-panel', component: EditorPanelComponent, canActivate: [AuthGuard], data: {roles: [Role.User]},
    children: [
      {path: 'editor-news', component: EditorNewsComponent},
      {path: 'editor-news/:id', component: EditorEditNewsComponent},
      {path: 'editor-create-news', component: EditorCreateNewsComponent},
      {path: 'editor-profile', component: UserProfileComponent},
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class EditorRoutingModule {
}
